import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

export interface HeaderBannerItem {
  type: string;
  title: string;
  link?: string;
  lastUpdate: string;
}

@Component({
  selector: 'dottnet-header-banner',
  standalone: true,
  imports: [CommonModule, RouterLink, TranslatePipe],
  templateUrl: './header-banner.component.html',
  styleUrls: ['./header-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderBannerComponent {
  readonly items = input<HeaderBannerItem[] | null>(null);
}
